import { HisSearchResultRow } from 'hisng';
import { AbstractDetailViewListEntry, SimpleLinkDefinition, RowLabels } from './abstract-detail-view-list-entry';
import { DetailViewListUtils } from './detail-view-list-utils';


export class PublicationDetailViewListEntry extends AbstractDetailViewListEntry {

    rowLabels: RowLabels = {
        type: 'fs.res.publication.Publication.publicationType',
        qualificationThesisHiskey: 'fs.res.publication.QualificationThesisValue',
        qualificationThesisText: 'fs.res.publication.QualificationThesisValue.longtext',
        peerReviewed: 'fs.res.publication.view.peerReviewed',
        openAccess: 'fs.res.publication.view.openAccess',
        title: 'fs.res.publication.Publication.title',
        creators: 'fs.res.publication.Publication.creators',
        creatorType: 'fs.res.publication.PublicationCreatorTypeValue',
        releaseYear: 'fs.res.publication.Publication.releaseYear'
    };

    getOverSearchResultLink(): SimpleLinkDefinition {
        return null;
    }

    getSubheading(row: HisSearchResultRow, data: any, index: number): string {
        return null;
    }

    getHeaderLine(row: HisSearchResultRow): string {
        const OPEN_ACCESS = '4';
        const PEER_REVIEWED = '1';
        const NONE_QUALIFICATION_THESIS = '3';
        let text = DetailViewListUtils.capitalizeFirstLetter(DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['type']));
        const qualificationThesisHiskey = DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['qualificationThesisHiskey']);
        if (qualificationThesisHiskey && qualificationThesisHiskey !== NONE_QUALIFICATION_THESIS) {
            text += ' |' + DetailViewListUtils.capitalizeFirstLetter(
                DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['qualificationThesisText']));
        }

        if (DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['peerReviewed']) === PEER_REVIEWED) {
            text += ' ' + this.hisUiService.translate('fs.res.publication.view.peerReviewed');
        }

        if (DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['openAccess']) === OPEN_ACCESS) {
            text += ' ' + this.hisUiService.translate('fs.res.publication.view.openAccess');
        }
        return text;
    }

    getTitleLine(row: HisSearchResultRow): string {
        return DetailViewListUtils.getRowByLabelKey(row, this.rowLabels.title);
    }

    getToolTip(row: HisSearchResultRow): string {
        return DetailViewListUtils.assembleToolTip(this.hisUiService.translate('fs.res.publication.Publication'),
            DetailViewListUtils.getRowByLabelKey(row, this.rowLabels.title), this.hisBaseGlobalsService, this.hisUiService);
    }

    getTitleLink(row: HisSearchResultRow): string {
        return `/a/fs.res.frontend/pub/view/${row.get('Publication.id')}` +
            '?showBackButton=true&showSearchButton=false';
    }

    getExtendableLine(row: HisSearchResultRow, i: number, first: number, rowsPerPage: number): string {
        const PUBLICATION_CREATOR_TYPE_EDITORS = [2, 4, 6];
        const allCreatorNames = DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['creators']);
        const allCreatorNamesSplit = allCreatorNames ? allCreatorNames.split(', ') : [];
        const firstCreatorNames = `${allCreatorNamesSplit[0]}, ${allCreatorNamesSplit[1]}, ${allCreatorNamesSplit[2]} et al.`;
        const creatorType = DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['creatorType']);
        const isCreatorTypeEditor = PUBLICATION_CREATOR_TYPE_EDITORS.indexOf(creatorType) >= 0;
        const editorTextPrefix = this.hisUiService.translate('fs.res.publication.Publication.editor.detailtext') + ': ';
        let text;

        if(allCreatorNamesSplit.length === 0 ) {
            text = '';
        } else if (this.shouldShowFullMemberList(allCreatorNamesSplit, i, first, rowsPerPage)) {
            text = isCreatorTypeEditor ? editorTextPrefix + allCreatorNames : allCreatorNames;
        } else {
            text = isCreatorTypeEditor ? editorTextPrefix + firstCreatorNames : firstCreatorNames;
        }
        return text;
    }

    shouldShowFullMemberList(allCreatorNamesSplit: any, i: number, first: number, rowsPerPage: number) {
        return allCreatorNamesSplit.length <= 3 || this.personDetailViewSearchResultComponent.isShowExtendableLine(i, first, rowsPerPage);
    }

    getExtendableLineSecond(row: HisSearchResultRow, i: number, first: number, rowsPerPage: number): string {
        return null;
    }

    isExtendable(row: HisSearchResultRow): boolean {
        const allCreatorNames = DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['creators']);
        const allCreatorNamesSplit = allCreatorNames ? allCreatorNames.split(', ') : [];
        return allCreatorNamesSplit.length > 3;
    }

    isExtendableSecond(row: HisSearchResultRow): boolean {
        return false;
    }

    getFooterLine(row: HisSearchResultRow): string {
        return `${this.hisUiService.translate('fs.res.finance.project.table.header.publication.releaseYear')}: ` +
            DetailViewListUtils.getRowByLabelKey(row, this.rowLabels['releaseYear']);
    }

}
